export default "__VITE_ASSET__BSylyI5O__"